import authApiService from '@/modules/auth/services/auth.api'
import childrenApiService from '@/modules/children/services/children.api'

const login = (context, options)  => {
  return new Promise((resolve, reject) => {
    authApiService.login({ email: options.email, password: options.password, client_id: options.client_id })
    .then(response => {

      if (response.data.nurseries && response.data.nurseries.data && response.data.nurseries.data.length == 1 && response.data.nurseries.data.find( nursery => nursery.is_suspended)) {
        reject('This provider has been suspended. Please contact your Administrator!')
        return
      }

      if (response.data.role && response.data.role.slug === 'carer') {
        context.dispatch('logout')
        reject('You are not allowed to access this portal. Please contact support.')
        return
      }
      context.commit('SET_USER', response.data)
      context.commit('SET_JWT', response.data.token)
      
      // Associate guest basket items if there's a basketUID in localStorage
      const basketUID = context.rootGetters['basket/basketUID']
      const basketPromises = []
      
      if (basketUID) {
        basketPromises.push(
          context.dispatch('basket/associateGuestItems', basketUID, { root: true })
            .catch(() => {
              // If association fails, continue anyway
            })
        )
      }
      
      // Always fetch basket items for the user
      basketPromises.push(
        context.dispatch('basket/fetchBasket', null, { root: true })
          .catch(() => {
            // If fetch fails, continue anyway
          })
      )
      
      // Wait for basket operations to complete, but don't block login
      Promise.all(basketPromises).finally(() => {
        resolve(response)
      })
    }).catch(error => {
      reject(error.response)
    })
  })
}


let isRefreshing = false
const refresh = (context, options) => {
  //get the ttl for the current token
  const [header, payload, signature] = context.getters.jwt.split('.')
  const data = JSON.parse(atob(payload))
  const expirationTimeInSeconds = data.exp
  const currentTimeInSeconds = Math.floor(Date.now() / 1000)
  const ttlInSeconds = expirationTimeInSeconds - currentTimeInSeconds

  //if we aren't refreshing already and the ttl is less than 10 minutes
  if(!isRefreshing && ttlInSeconds < 10 * 60) {
    isRefreshing = true
    
    return authApiService.refresh()
    .then((response) => {
      context.commit('SET_JWT', response.data.token)
    })
    .finally(() => {
      isRefreshing = false
    })
  }
}

const autoLogin = (context, user)  => {
  localStorage.removeItem('activeBranch');
  context.commit('SET_USER', user)
  context.commit('SET_JWT', user.token)
}

const logout = (context, options)  => {
  return new Promise((resolve, reject) => {
    authApiService.logout().then(response => {
      context.commit('SET_JWT', '')
      context.commit('SET_USER', null)
      context.commit('SET_ACTIVE_NURSERY', null)
      context.commit('SET_ACTIVE_NURSERY_BRANCH', null)
      context.commit('SET_USER_HAS_COMPLETED_MIGRATION', false)
      context.commit('SET_ROLE', null)
      context.commit('SET_JUMP', false)
      context.commit('SET_ENABLE_MARKETPLACE', null)
      // Clear basket on logout - use dispatch to ensure action completes
      context.dispatch('basket/emptyBasket', null, { root: true })
        .then(() => {
          resolve(response)
        })
        .catch(() => {
          // Even if action fails, resolve logout
          resolve(response)
        })
    }).catch(error => {
      context.commit('SET_JWT', '')
      context.commit('SET_USER', null)
      context.commit('SET_ACTIVE_NURSERY', null)
      context.commit('SET_ACTIVE_NURSERY_BRANCH', null)
      context.commit('SET_USER_HAS_COMPLETED_MIGRATION', false)
      context.commit('SET_ROLE', null)
      context.commit('SET_JUMP', false)
      context.commit('SET_ENABLE_MARKETPLACE', null)
      // Clear basket on logout even if API call fails - use dispatch to ensure action completes
      context.dispatch('basket/emptyBasket', null, { root: true })
        .then(() => {
          resolve(error)
        })
        .catch(() => {
          // Even if action fails, resolve logout
          resolve(error)
        })
    })
  })
}

const autoLogout = (context, user)  => {
  context.commit('SET_JWT', '')
  context.commit('SET_USER', null)
  context.commit('SET_ACTIVE_NURSERY', null)
  context.commit('SET_ACTIVE_NURSERY_BRANCH', null)
  context.commit('SET_ROLE', null)
  // Clear basket on auto logout
  context.dispatch('basket/emptyBasket', null, { root: true })
    .catch(() => {
      // Even if action fails, continue with logout
    })
}

const user = (context, options)  => {
  return new Promise((resolve, reject) => {
    authApiService.user()
    .then(response => {
      context.commit('SET_USER', response.data)
      context.commit('SET_JWT', response.data.token)
      // context.commit('SET_OPENING_TIMES', response.data.nurseries.data[0]? response.data.nurseries.data[0].branches? response.data.nurseries.data[0].branches.data[0].opening_times.data  : null : null )
      resolve(response)
    }).catch(error => {
      reject(error.response)
    })
  })
}

const authCheck = (context, options)  => {
  return new Promise((resolve, reject) => {
    if (context.getters.userIsLoggedIn) {
      authApiService.user({ client_id: 3 })
        .then(response => {
          context.commit('SET_USER', response.data)
          context.commit('SET_JWT', response.data.token)
          context.commit('SET_AUTH_IS_READY', true)
          // context.commit('SET_OPENING_TIMES', response.data.nurseries.data[0]? response.data.nurseries.data[0].branches? response.data.nurseries.data[0].branches.data[0].opening_times.data  : null : null )
          resolve(response.data)
        }).catch(error => {
          context.commit('SET_AUTH_IS_READY', true)
          reject(error)
        })
    } else {
      context.commit('SET_AUTH_IS_READY', true)
      resolve()
    }
  })
}

const updateProfile = (context, options)  => {
  return new Promise((resolve, reject) => {
    authApiService.updateProfile(options)
    .then(response => {
      context.dispatch('user')
      resolve(response)
    }).catch(error => {
      reject(error.response)
    })
  })
}

const switchToCarerAccount = (context)  => {
  return new Promise((resolve, reject) => {
    authApiService.toggleCarerAccount()
    .then(response => {
      context.commit('SET_USER', response.data)
      context.commit('SET_JWT', response.data.token)
      resolve(response)
    }).catch(error => {
      reject(error.response)
    })
  })
}

const switchToServiceAccount = (context)  => {
  return new Promise((resolve, reject) => {
    authApiService.toggleServiceAccount()
    .then(response => {
      context.commit('SET_USER', response.data)
      context.commit('SET_JWT', response.data.token)
      resolve(response)
    }).catch(error => {
      reject(error.response)
    })
  })
}

const subscriptionToEmailUpdate = (context)  => {
  return new Promise((resolve, reject) => {
    authApiService.toggleUserSubscriptionToServiceEmailUpdates()
    .then(response => {
      context.dispatch('user')
      resolve(response)
    }).catch(error => {
      reject(error.response)
    })
  })
}

const deletePaymentMethod = (context, paymentMethodId) => {
  return childrenApiService.carer.deletePaymentMethod(paymentMethodId)
    .then(response => {
      context.commit('REMOVE_USER_PAYMENT_METHOD', paymentMethodId)
      // Also clear this payment method from any basket items that reference it
      context.commit('basket/CLEAR_PAYMENT_METHOD_FROM_BASKET', paymentMethodId, { root: true })
      return response
    })
}

export default {
  login,
  refresh,
  autoLogin,
  logout,
  autoLogout,
  user,
  authCheck,
  updateProfile,
  switchToCarerAccount,
  switchToServiceAccount,
  subscriptionToEmailUpdate,
  deletePaymentMethod,
}
